import { Screen } from '~/screens/users/[userId]/edit';

export const UsersEdit: React.FC = () => <Screen />;
